require('./loanHeaderDetails.scss');

const PropTypes = require('prop-types');

//@vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
//@core
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
//@components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

class LoanHeaderDetails extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render () {
        const { immLoan } = this.props;
        const balance = immLoan.get('balance');
        const plainAmountObject = getPlainAmountObject(balance);

        return (
            <div className="loan-header-details">
                <div className="loan-header-details__section">
                    <span className="loan-header-details__amount">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            className="loan-header-details__amount"
                            positiveAmount={true}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />
                    </span>
                    <span className="loan-header-details__subtitle">
                        <FormattedText value="loan-countableBalance" />
                    </span>
                </div>
            </div>
        );
    }
}

LoanHeaderDetails.propTypes = {
    immLoan: PropTypes.object.isRequired
}

module.exports = LoanHeaderDetails;